import { render, staticRenderFns } from "./ComposerEditLogic.vue?vue&type=template&id=0d585432&scoped=true"
import script from "./ComposerEditLogic.vue?vue&type=script&lang=js"
export * from "./ComposerEditLogic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d585432",
  null
  
)

export default component.exports